<template>
  <div class="main-box">
    <!-- applyStatus 00:核卡成功 其他:未收到核卡反馈 -->
    <img src="@/assets/images/cmbCreditCard/title_bg.png" class="title-img" />
    <div class="apply-box">
      <template v-if="applyStatus !== '00'">
        <img
          src="@/assets/images/cmbCreditCard/join_now.png"
          alt="立即申请"
          class="apply-img"
          @click="goJoin"
        />
        <!-- 文案 -->
        <div class="receive-rights">如已完成申请，请耐心等待招商银行审核！</div>
      </template>
      <!-- 三个月券 -->
      <div :class="`coupons-box coupons-box${applyStatus}`">
        <div
          v-for="(item, index) in couponsList"
          :key="index"
          class="coupons-content"
        >
          <img
            :src="require(`@/assets/images/cmbCreditCard/coupons${index}.png`)"
            class="coupons-img"
          />
          <!-- 优惠券-金额 -->
          <div class="coupons-money">
            <div>{{ item.batchMoney }}</div>
            <div class="yuan">元</div>
          </div>
          <!-- 无门槛 -->
          <div class="no-threshold">无门槛</div>
          <!-- 优惠券-名称 -->
          <div class="coupons-name">
            {{ item.showTitle }}
          </div>
          <!-- 优惠券-使用规则 -->
          <div class="coupons-use-rules">{{ item.usedDes || '使用规则：有效期1个月、单次仅限使用1张' }}</div>
          <!-- 操作按钮 -->
          <div
            :class="`coupons-status coupons${item.state}`"
            @click="receiveCoupon(item.batchId)"
          >
            {{ changeStateText(item.state) }}
          </div>
        </div>
      </div>
      <!-- <div
        v-if="applyStatus !== '00'"
        class="receive-rights underline"
        @click="showMoreRights"
      >
        点击查看更多招商银行信用卡权益
      </div> -->
      <!-- 使用规则 -->
      <div class="activity-rules-box">
        <div class="activity-title">使用规则</div>
        <div class="activity-rules">
          <div class="rules-item">
            ①<span>优惠券有效时长1个月，单次通行仅限使用1张优惠券；</span>
          </div>
          <div class="rules-item">
            ②<span>每次通行只可使用1张优惠券；</span>
          </div>
          <div class="rules-item">
            ③<span>优惠券不兑现、不找零、不开具发票。</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
import { setStore } from '@/utils/index'
import {
  getApplyStatus,
  participateInActivity,
  receiveCoupon
} from '@/api/cmbCreditCard'
export default {
  name: 'cmbCreditCardRights',
  data () {
    return {
      applyStatus: '00', // 00:核卡成功 其他:未收到核卡反馈
      // state 1:可领取 2:已领取 3:已抢光 4:未开始 5:已过期
      couponsList: [
        // {
        //   status: '5',
        //   statusText: '已过期'
        // },
        // {
        //   status: '1',
        //   statusText: '立即领取'
        // },
        // {
        //   status: '4',
        //   statusText: '暂未开始'
        // }
      ]
    }
  },
  created () {
    const token = this.$route.query.token
    if (token) {
      setStore('token', token)
      this.getApplyStatus()
    }
  },
  methods: {
    // 获取申请状态及三个月券的状态
    getApplyStatus () {
      const { activeId } = this.$route.query
      const params = {
        activeId // 活动编号
      }
      getApplyStatus(params).then(res => {
        const resData = res.data
        if (resData.code === 200) {
          this.couponsList = resData.result.activityCouponsVos
          this.applyStatus = resData.result.status
        } else {
          Toast({
            message: resData.message
          })
        }
      })
    },
    // 立即参加
    goJoin () {
      const { activeId } = this.$route.query
      const params = {
        activeId // 活动编号
      }
      participateInActivity(params).then(res => {
        const resData = res.data
        if (resData.code === 200 && resData.result) {
          // 跳转招行信用卡申请页面
          window.location.href = 'https://res.cc.cmbimg.com/itafront/Frog/index.html#/login3/api3xxylhj/remote?webAddress=N47FHXM2018X404500HZ&dsid=288184'
        } else {
          Toast({
            message: resData.message
          })
        }
      })
    },
    // 领取优惠券
    receiveCoupon (batchId) {
      const { activeId } = this.$route.query
      const params = {
        activeId, // 活动编号
        batchId, // 批次ID
        channel: '99' // 领取渠道
      }
      receiveCoupon(params).then(res => {
        const resData = res.data
        if (resData.code === 200) {
          console.log('res=', resData.result.activityCouponsVos)
          // 领取成功后刷新列表
          this.getApplyStatus()
        } else {
          Toast({
            message: resData.message
          })
        }
      })
    },
    // 状态-转换为中文
    // state 1:可领取 2:已领取 3:已抢光 4:未开始 5:已过期
    changeStateText (state) {
      let text = ''
      switch (state) {
        case 1:
          text = '可领取'
          break
        case 2:
          text = '已领取'
          break
        case 3:
          text = '已抢光'
          break
        case 4:
          text = '未开始'
          break
        case 5:
          text = '已过期'
          break
        case 6:
          text = '不可领取'
          break
        default:
          text = '不可领取'
          break
      }
      return text
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/cmbCreditCard.scss";
.apply-img {
  max-width: 100%;
  padding-top: (203vw / 7.5);
}

.receive-rights {
  margin-bottom: (30vw / 7.5);
}

// 三个月券
.coupons-box {
  width: (700vw / 7.5);
  margin: 0 auto;
  // padding-top: (435vw / 7.5);

  .coupons-content {
    position: relative;
    display: flex;
    width: (700vw / 7.5);
    height: (338vw / 7.5);
    margin-bottom: (30vw / 7.5);
  }

  .coupons-img {
    max-width: 100%;
  }

  .coupons-money {
    display: flex;
    align-items: baseline;
    justify-content: center;

    position: absolute;
    top: (149vw / 7.5);
    left: (17vw / 7.5);
    // left: (64vw / 7.5);

    width: (175vw / 7.5);
    white-space: nowrap;
    font-size: (67.5vw / 7.5);
    line-height: (65vw / 7.5);
    font-family: SF Pro Display, SF Pro Display-Bold;
    font-weight: 700;
    color: #e33f3c;
    letter-spacing: (-10vw / 7.5);

    .yuan {
      margin-left: (8vw / 7.5);
      font-size: (34vw / 7.5);
      font-family: Source Han Sans CN, Source Han Sans CN-Bold;
    }
  }

  .no-threshold {
    position: absolute;
    left: (54vw / 7.5);
    bottom: (73vw / 7.5);

    width: (110vw / 7.5);
    // height: (36vw / 7.5);
    background: #da3833;
    border-radius: (18vw / 7.5);
    font-size: (24vw / 7.5);
    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
    font-weight: 400;
    text-align: center;
    color: #fff5da;
    line-height: (36vw / 7.5);
  }

  .coupons-name {
    position: absolute;
    top: (130vw / 7.5);
    left: (207vw / 7.5);

    font-size: (40vw / 7.5);
    font-family: Source Han Sans CN, Source Han Sans CN-Bold;
    font-weight: 700;
    text-align: left;
    color: #fff5da;
    padding-right: (18vw / 7.5);

    // 超过一行显示省略号
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  .coupons-use-rules {
    position: absolute;
    top: (194vw / 7.5);
    left: (204vw / 7.5);

    max-height: (50vw / 7.5);
    line-height: (25vw / 7.5);
    padding-right: (18vw / 7.5);
    font-size: (22vw / 7.5);
    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
    font-weight: 400;
    text-align: left;
    color: #fff5da;

    // 超过两行显示省略号
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .coupons-status {
    position: absolute;
    right: (40vw / 7.5);
    bottom: (50vw / 7.5);

    width: (130vw / 7.5);
    height: (44vw / 7.5);
    line-height: (44vw / 7.5);
    opacity: 1;
    font-size: (24vw / 7.5);
    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
    font-weight: 400;
    color: #666;
    background: #cccccc;
    border-radius: (22vw / 7.5);

    &:active {
      opacity: 0.8;
    }
  }

  // 1:可领取 2:已领取 3:已抢光 4:未开始 5:已过期
  .coupons1 {
    color: #da3833;
    background: linear-gradient(174deg, #fff5da 0%, #ffde97 38%, #ffc424 100%);
  }

  .coupons4 {
    opacity: 0.5;
    color: #da3833;
    background: linear-gradient(174deg, #fff5da 0%, #ffde97 38%, #ffc424 100%);
  }
}

// 三个月券-未收到核卡反馈
// .coupons-box11 {
//   padding-top: (435vw / 7.5);
// }

// 三个月券-已申请成功
.coupons-box00 {
  padding-top: (272vw / 7.5);
}
</style>
